/**
 * @generated SignedSource<<65f27c3b09bb875f6f509c6fba86fab6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcceptDismissPopoverDismissMutation$variables = {
  actionItemIds: ReadonlyArray<string>;
};
export type AcceptDismissPopoverDismissMutation$data = {
  readonly dismissAiActionItems: {
    readonly ok: boolean | null;
  } | null;
};
export type AcceptDismissPopoverDismissMutation = {
  response: AcceptDismissPopoverDismissMutation$data;
  variables: AcceptDismissPopoverDismissMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "actionItemIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "actionItemIds",
        "variableName": "actionItemIds"
      }
    ],
    "concreteType": "DismissAiActionItems",
    "kind": "LinkedField",
    "name": "dismissAiActionItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptDismissPopoverDismissMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptDismissPopoverDismissMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4294d01b8a88a27e702630087308af7f",
    "id": null,
    "metadata": {},
    "name": "AcceptDismissPopoverDismissMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptDismissPopoverDismissMutation(\n  $actionItemIds: [ID!]!\n) {\n  dismissAiActionItems(actionItemIds: $actionItemIds) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "eddad2335cbc392485259b30f9ab5e8b";

export default node;
